import React, { useContext } from 'react'
import { useLoaderData } from 'react-router'
import UserContext from '../../../context/UserContext'
import FeedbackEndOfTherapyThankYouPage from './FeedbackEndOfTherapyThankYouPage'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackEndOfTherapyThankYouModule = () => {
  const loaderData = useLoaderData()
  const { currentEnrolment } = useContext(UserContext)

  const { id } = currentEnrolment

  return (
    <FeedbackEndOfTherapyThankYouPage
      content={loaderData.page.content}
      enrolmentId={id}
    />
  )
}

export default FeedbackEndOfTherapyThankYouModule
